import React from 'react';
import TextField from '@mui/material/TextField';
import { useState } from 'react';

interface TextEntryProps {
    value: string;
    onChange: (event: any) => void;
    showError: boolean;
    label: string;
    validationFunction: (value: string) => boolean;
}

export function TextEntry({
    value,
    onChange,
    showError,
    label,
    validationFunction
}: TextEntryProps) {
    const isError = !validationFunction(value) && showError;
    return <TextField 
        error={isError}
        id={`${label}`}
        label={label}
        value={value}
        onChange={onChange}
        sx={{ m: 1 }}
    />
}

export function useTextEntry(
    initialValue: string, 
    showError: boolean,
    label: string,
    validationFunction: (value: string) => boolean
) {
    const [value, setV] = useState<string>(initialValue);
    const [isValid, setIsValid] = useState<boolean>(
        validationFunction(value)
    );
    const setValue = (value: string) => {
        setV(value);
        setIsValid(validationFunction(value));
    }
    const onChange = (event: any) => {
        setValue(event.target.value);
    }
    const component = <TextEntry
        value={value}
        onChange={onChange}
        showError={showError}
        label={label}
        validationFunction={validationFunction} 
    />

    return {
        component,
        value,
        setValue,
        isValid
    }
}